import { GeoJsonObject } from 'geojson'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface CheckRegionsPayload {
  region_id: number
  project_id: number
  geojson: GeoJsonObject
}

interface Polygons {
  name: string
  id: string
  intersection_percentage: number
}

export interface CheckRegionsResponse {
  matching: Polygons[]
  unmatching: number
}

export async function checkRegions(payload: CheckRegionsPayload) {
  const { data } = await companiesApi.post<CheckRegionsResponse>(
    apiRoutes.checkRegions,
    payload,
  )

  return data
}
